<template>
  <admin-layout
    menu="Vagas"
    :customStyle="{ backgroundColor: '#fcfcfc' }"
  >
    <title>
      {{ job_edit ? "Editar Vaga" : "Crie uma Vaga" }}
    </title>
    <div class="row">
      <div
        class="col-lg-9 col-md-7 col-xs-12 overflow-auto"
        style="height: 85vh"
      >
        <div class="row">
          <div class="col-lg-12">
            <span class="ml-3 f14 font-weight-bold">TÍTULO DA VAGA</span>
            <inputform
              v-model="jobs.title"
              type="text"
              :field="$v.jobs.title"
              class="label-bold mt-2"
            />
          </div>
          <div class="col-lg-4 col-xs-12">
            <span class="ml-3 f14 font-weight-bold">CIDADE</span>
            <VueSuggestion
              searchURL="/cities"
              responseDataName="cities"
              :focusOut="hasCity"
              :selectedEl="city"
              :whenSelected="setCity"
              placeholder="CIDADE"
              classes="mt-1"
            />
          </div>
          <div class="col-lg-4 col-xs-12">
            <span class="ml-3 f14 font-weight-bold">ÁREA</span>
            <VueSuggestion
              searchURL="/recruiters/job_sectors"
              responseDataName="job_sectors"
              placeholder="ÁREA"
              v-model="job_sector.title"
              :selectedEl="job_sector"
              :clearOption="true"
              :camelCase="true"
              :whenSelected="(sector) => (job_sector.id = sector.id)"
              classes="mt-1"
              inputClasses="radius-0 form-control"
            />
          </div>
          <div class="col-lg-12 col-xs-12">
            <hr class="bg-aqua my-4" />
          </div>
          <div class="col-lg-12">
            <span class="ml-3 f14 font-weight-bold">DESCRIÇÃO DA VAGA</span>
            <ckeditor
              v-model="jobs.description"
              @blur="populateKanban"
              class="mt-2"
              :class="{
                'is-invalid': $v.jobs.description.$error,
                'is-valid': !$v.jobs.description.$invalid,
              }"
            />
          </div>
          <div class="col-lg-12 mt-3">
            <span class="ml-3 f14 font-weight-bold">BENEFÍCIOS</span>
            <VueTagsInput
              v-model="benefits"
              class="full mt-2"
              :tags="jobs.benefits"
              @adding-duplicate="$toast.error('Esta tag já foi inserida')"
              @tags-changed="(newTags) => (jobs.benefits = newTags)"
            />
          </div>
          <div class="col-lg-12 mt-3">
            <span class="ml-3 f14 font-weight-bold">HABILIDADES COMPORTAMENTAIS</span>
            <VueTagsInput
              v-model="behavioral"
              class="full mt-2 pb-3"
              :tags="jobs.behavioral"
              @before-adding-tag="isDuplicated($event, 1)"
              @adding-duplicate="$toast.error('ESTA TAG JÁ FOI INSERIDA')"
              @tags-changed="(newTags) => (jobs.behavioral = newTags)"
            />
          </div>
          <div class="col-lg-4 col-xs-12">
            <span class="ml-3 f14 font-weight-bold mb-2">DATA DE ENTREGA</span>
            <Datepicker
              type="datetime"
              v-model="jobs.date_shortlist"
              input-class="form-control bg-white"
              :language="ptBR"
            ></Datepicker>
          </div>
          <div class="col-lg-4 col-xs-12">
            <span class="ml-3 f14 font-weight-bold mb-2">DATA DE CONCLUSÃO</span>
            <Datepicker
              type="datetime"
              v-model="jobs.date_conclusion"
              input-class="form-control bg-white"
              :language="ptBR"
            ></Datepicker>
          </div>
          <div class="col-lg-12">
            <hr class="bg-aqua my-4" />
          </div>
          <div class="col-lg-12 mt-3">
            <div class="row">
              <div class="col-lg-4 col-md-5 col-xs-12">
                <span class="ml-3 f14 font-weight-bold">SALÁRIO MENSAL</span>
                <currency-input
                  v-model="jobs.minimum_remuneration"
                  class="form-control mt-2"
                  placeholder="0,00"
                />
              </div>
              <div class="col-lg-1 col-md-2 col-xs-12 text-center mt-3 pt-4">
                <span v-if="range_salary">ATÉ</span>
              </div>
              <div
                class="col-lg-4 col-md-5 col-xs-12"
                v-if="range_salary"
              >
                <span class="ml-3 f14 font-weight-bold"></span>
                <currency-input
                  v-model="jobs.maximum_remuneration"
                  class="form-control mt-2"
                  placeholder="0,00"
                />
              </div>
            </div>
            <div class="row mt-2 pb-3">
              <div class="col-lg-4 col-xs-12">
                <button
                  @click="changeSalary"
                  class="btn btn-primary full radius-0 f13 h-100"
                >
                  {{
                    range_salary
                      ? "ADICIONAR SALÁRIO FIXO"
                      : "CADASTRAR FAIXA SALÁRIAL"
                  }}
                </button>
              </div>
              <div class="col-lg-4 col-xs-12 py-2">
                <SwitchCheckbox
                  v-model="jobs.hide_remuneration"
                  :value="jobs.hide_remuneration"
                  label="OCULTAR O SALÁRIO DA VAGA"
                />
              </div>
              <div class="col-lg-4 col-xs-12 py-2">
                <SwitchCheckbox
                  v-model="jobs.ask_remuneration"
                  :value="jobs.ask_remuneration"
                  label="PERGUNTAR SOBRE O SALÁRIO"
                />
              </div>
            </div>
            <hr class="bg-aqua my-4" />
          </div>
          <div class="col-lg-12 mt-3">
            <div class="row ml-2">
              <div class="col-lg-12 mt-2">
                <SwitchCheckbox
                  v-model="jobs.hide_business"
                  :value="jobs.hide_business"
                  label="DEIXAR O NOME DA EMPRESA CONFIDENCIAL"
                />
              </div>
              <div class="col-lg-12 mt-2">
                <SwitchCheckbox
                  v-model="jobs.hide_confirm_experiences"
                  :value="jobs.hide_confirm_experiences"
                  label="ESCONDER CONFIRMAÇÃO DE EXPERIÊNCIAS PROFISSIONAIS E EDUCACIONAIS"
                />
              </div>
              <div class="col-lg-12 mt-2">
                <SwitchCheckbox
                  v-model="jobs.hide_upload_cv"
                  :value="jobs.hide_upload_cv"
                  label="NÃO PERMITIR UPLOAD DO CV DURANTE A INSCRIÇÃO"
                />
              </div>
              <div class="col-lg-12 mt-2">
                <SwitchCheckbox
                  v-model="jobs.mandatory_cv"
                  :value="jobs.mandatory_cv"
                  label="UPLOAD DO CV DURANTE A INSCRIÇÃO OBRIGATÓRIO"
                />
              </div>
              <div class="col-lg-12 mt-2">
                <SwitchCheckbox
                  v-model="jobs.mandatory_portfolio"
                  :value="jobs.mandatory_portfolio"
                  label="SOLICITAR O PORTFOLIO DE CANDIDATO(A)"
                />
              </div>
              <div class="col-lg-12 mt-2">
                <SwitchCheckbox
                  v-model="jobs.candidates_uniques"
                  :value="jobs.candidates_uniques"
                  label="CANDIDATO ÚNICO POR CPF"
                />
              </div>
              <div class="col-lg-12 mt-2">
                <SwitchCheckbox
                  v-model="jobs.question_last_work"
                  :value="jobs.question_last_work"
                  label="PERGUNTAR ULTIMO CARGO/EMPRESA"
                />
              </div>
              <div class="col-lg-12 mt-2">
                <SwitchCheckbox
                  v-model="jobs.has_hometown"
                  :value="jobs.has_hometown"
                  label="PERGUNTAR CIDADE NATAL"
                />
              </div>
              <div class="col-lg-12 mt-2">
                <SwitchCheckbox
                  v-model="jobs.has_is_pcd"
                  :value="jobs.has_is_pcd"
                  label="PERGUNTAR PCD"
                />
              </div>
              <div class="col-lg-12 mt-2">
                <SwitchCheckbox
                  v-model="jobs.has_ethnicity"
                  :value="jobs.has_ethnicity"
                  label="PERGUNTAR ETINIA"
                />
              </div>
              <div class="col-lg-12 mt-2">
                <SwitchCheckbox
                  v-model="jobs.has_sexual_orientation"
                  :value="jobs.has_sexual_orientation"
                  label="PERGUNTAR ORIENTACAO SEXUAL"
                />
              </div>
              <div class="col-lg-12 mt-2 mb-3">
                <Bigfive
                  :jobs="jobs"
                  :job_id="job_id"
                  :amount="bigfive.amount_itens"
                  :selective_process="
                    bigfive_edit ? bigfive_edit.selective_process_id : null
                  "
                />
              </div>

            </div>
            <hr class="bg-aqua my-4" />
          </div>
          <div class="col-lg-12 col-xs-12 mt-3">
            <JobSkills :job_id="job_id" />
          </div>
          <div
            class="col-lg-12 col-xs-12 mt-3"
            v-if="showKanban"
          >
            <div class="row">
              <div class="col-lg-12 col-xs-12">
                <span class="ml-3 f14 font-weight-bold">ETAPAS DO PROCESSO SELETIVO</span>
              </div>
              <div class="col-lg-12 col-xs-12">
                <span class="ml-3 f14 color-primary">ADICIONE OU REORGANIZE ETAPAS DO PROCESSO SELETIVO PARA ESTA
                  VAGA
                </span>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-12">
                <Kanban
                  id="kanban"
                  :gallery="gallery || gallery_current"
                  :recruiter_id="recruiter_id"
                  :job_id="job_id"
                  style="text-transform: uppercase"
                />
              </div>
            </div>
            <hr class="bg-aqua my-4" />
          </div>
          <div class="col-lg-12 col-xs-12 mt-3">
            <div class="row">
              <div class="col-lg-12 col-xs-12">
                <span class="ml-3 f14 font-weight-bold">ADICIONE VÍDEOS A JORNADA DE CANDIDATO(A)</span>
              </div>
              <div class="col-lg-12 col-xs-12">
                <span class="ml-3 f14 color-primary">
                  CRIE OU ADICIONE VÍDEOS APRESENTADO A EMPRESA OU A VAGA
                </span>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-4 col-xs-12">
                <button
                  class="btn btn-primary full p-2 radius-0 f13"
                  @click="addInstitutional"
                >
                  ADICIONAR VÍDEO
                </button>
              </div>
              <div class="col-lg-8 col-xs-12">
                <div class="row">
                  <div
                    v-for="(institutional, index) in institutionals"
                    :key="index"
                    class="col-lg-12 col-xs-12"
                  >
                    <InstitutionalVideo
                      :item="institutional"
                      :index="index"
                      :job_id="job_id"
                      :gallery_current="gallery_current"
                      @deleteInstitutional="deleteInstitutional($event)"
                      @setInstitutionalIndex="setInstitutionalIndex"
                      :requestSave="requestSave"
                      :reference_id="job_id"
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr class="bg-aqua my-4" />
          </div>
          <div class="col-lg-12 col-xs-12 mt-3">
            <div class="row">
              <div class="col-lg-12 col-xs-12">
                <span class="ml-3 f14 font-weight-bold">CRIE SUA PROVA</span>
              </div>
              <div class="col-lg-12 col-xs-12">
                <span class="ml-3 f14 color-primary">ADICIONE PROVAS COMO AGRUPAMENTO DE PERGUNTAS</span>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-4 col-xs-12">
                <button
                  @click="addEvaluations"
                  class="btn btn-primary full f13 radius-0 p-2"
                >
                  ADICIONAR PROVA
                </button>

              </div>
              <div class="col-lg-8 col-xs-12">
                <Evaluations
                  :job_id="job_id"
                  v-if="has_evaluations"
                />
              </div>

            </div>
            <hr class="bg-aqua mt-4 mb-0" />
          </div>
          <div class="col-lg-12 col-xs-12 mt-3">
            <div class="row">
              <div class="col-lg-12 col-xs-12">
                <span class="ml-3 f14 font-weight-bold">CRIE SUA ENTREVISTA ON DEMAND</span>
              </div>
              <div class="col-lg-12 col-xs-12">
                <span class="ml-3 f14 color-primary">ADICIONE PERGUNTAS OU USE UM TEMPLATE CIADO
                  ANTERIORMENTE</span>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-4 col-xs-12">
                <button
                  @click="addQuestion"
                  class="btn btn-primary full f13 radius-0 p-2"
                >
                  ADICIONAR PERGUNTA
                </button>
                <button
                  @click="showSelectTemplate"
                  class="btn btn-primary full f13 radius-0 p-2 mt-2"
                >
                  USAR TEMPLATE
                </button>
              </div>
              <div class="col-lg-8 col-xs-12">
                <Questions
                  v-model="questions"
                  :questions_record="questions_record"
                  :job_id="job_id"
                />
              </div>
              <div class="col-lg-4"></div>
              <div class="col-lg-8">
                <button
                  v-if="questions.length > 1"
                  @click="addQuestion"
                  class="btn btn-primary full f13 radius-0 p-2"
                >
                  ADICIONAR OUTRA PERGUNTA
                </button>
              </div>
            </div>
            <hr class="bg-aqua mt-4 mb-0" />
          </div>
          <div class="col-lg-12 col-xs-12">
            <span
              @click="back"
              class="mt-1 btn btnhoverprimary"
              style="border-radius: 0px"
            >
              <font-awesome-icon
                icon="chevron-left"
                class="mr-3"
              />
              VOLTAR A LISTAGEM DE VAGA
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-5 col-xs-12 overflow-hidden">
        <div class="row">
          <div class="col-lg-12 formJov p-2">
            <div class="row">
              <div class="col-lg-12">
                <button
                  :disabled="load"
                  @click="save(true, true)"
                  type="buttom"
                  class="btn full btn-primary f13 p-2 radius-0"
                >
                  SALVAR
                </button>
              </div>
              <div class="col-lg-12 mt-3">
                <div class="selectInput">
                  <span class="f10 pl-3 color-grey">RESPONSÁVEL PELA VAGA</span>
                  <select
                    v-model="jobs.recruiter_id"
                    class="form-control"
                  >
                    <option
                      class="form-control"
                      v-for="recruiter in info_account"
                      :key="recruiter.id"
                      :value="recruiter.id"
                    >
                      {{ recruiter.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-12 mt-3">
                <div class="selectInput">
                  <span class="f10 pl-3 color-grey">STATUS DA VAGA</span>
                  <select
                    v-model="jobs.status"
                    class="form-control"
                  >
                    <option
                      v-for="status in statusJob"
                      :key="status.value"
                      :value="status.value"
                    >
                      {{ status.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-12 mt-3">
                <div class="selectInput">
                  <span class="f10 pl-3 color-grey">VISIBILIDADE DA VAGA</span>
                  <select
                    v-model="jobs.job_scope"
                    class="form-control"
                  >
                    <option
                      v-for="scope in job_scopes"
                      :key="scope.value"
                      :value="scope.value"
                    >
                      {{ scope.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-lg-12 formJov mt-3 p-2"
            v-if="job_id != 0"
          >
            <transition name="fade">
              <div class="row">
                <div class="col-lg-12">
                  <input
                    type="text"
                    id="linkShare"
                    class="form-control"
                    v-model="job_route"
                    readonly="true"
                  />
                </div>
                <div class="col-lg-12 mt-3">
                  <button
                    @click="copyCandidateLink"
                    class="btn full btn-primary f13 radius-0"
                  >
                    COPIAR LINK
                  </button>
                </div>
                <div class="col-lg-12 mt-3">
                  <span
                    @click="linkedin"
                    class="btn full btn-linkedin f13 radius-0"
                  >
                    <font-awesome-icon
                      class="mr-2"
                      :icon="['fab', 'linkedin']"
                    />COMPARTILHAR NO LINKEDIN
                  </span>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import moment from "moment";
import { format, addWeeks } from "date-fns";
import { required, minLength, email } from "vuelidate/lib/validators";
import Questions from "../Questions/Index.vue";
import Evaluations from "../Evaluations/Index.vue";
import KProgress from "k-progress";
import InstitutionalVideo from "@/Recruiters/Jobs/InstitutionalVideo.vue";
import VueTagsInput from "@johmun/vue-tags-input";
import SelectTemplate from "./SelectTemplate.vue";
import Kanban from "./Kanban.vue";
import Bigfive from "./Bigfive.vue";
import JobSkills from "./JobSkills.vue";
import SwitchCheckbox from "./SwitchCheckbox.vue";
import VueSuggestion from "components/VueSuggestion.vue";
import { ptBR } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";

export default {
  props: [
    "job_edit",
    "questions_record",
    "job_route_edit",
    "job_video",
    "itens_inst",
    "gallery",
    "recruiter_adm",
    "info_account",
    "bigfive_edit",
    "recruiter_id",
    "has_evaluations_edit",
  ],
  components: {
    Questions,
    KProgress,
    InstitutionalVideo,
    VueTagsInput,
    Kanban,
    Bigfive,
    SwitchCheckbox,
    VueSuggestion,
    Datepicker,
    JobSkills,
    Evaluations,
  },
  async mounted() {
    if (typeof this.job_edit == "object") {
      this.showKanban = true;
    }
    if (this.recruiter_id) this.jobs.recruiter_id = this.recruiter_id;

    if (this.gallery) {
      this.gallery_current = this.gallery;
    }

    if (this.has_evaluations_edit) {
      this.has_evaluations = true;
    }

    if (this.job_edit) {
      this.job_id = this.job_edit.id;

      this.institutionals = this.itens_inst;

      let behavioral = [];
      let benefits = [];
      if (this.job_edit.behavioral) {
        for (let i = 0; i < this.job_edit.behavioral.length; i++) {
          behavioral.push({
            text: this.job_edit.behavioral[i],
            tiClasses: ["ti-valid"],
          });
        }
      }
      if (this.job_edit.benefits) {
        for (let i in this.job_edit.benefits) {
          benefits.push({
            text: this.job_edit.benefits[i],
            tiClasses: ["ti-valid"],
          });
        }
      }

      this.jobs = {
        recruiter_id: this.job_edit.recruiter_id,
        title: this.job_edit.title,
        bigfive: this.job_edit.bigfive,
        question_last_work: this.job_edit.question_last_work,
        candidates_uniques: this.job_edit.candidates_uniques,
        bigfive_id: this.job_edit.bigfive_id,
        description: this.job_edit.description,
        benefits: benefits,
        maximum_remuneration: this.job_edit.maximum_remuneration,
        minimum_remuneration: this.job_edit.minimum_remuneration,
        hide_remuneration: this.job_edit.hide_remuneration,
        hide_upload_cv: this.job_edit.hide_upload_cv,
        hide_confirm_experiences: this.job_edit.hide_confirm_experiences,
        ask_remuneration: this.job_edit.ask_remuneration,
        link: this.job_edit.link,
        hide_business: this.job_edit.hide_business,
        deleted: this.job_edit.deleted,
        skills: [],
        behavioral: behavioral,
        status: this.job_edit.status,
        allow_notification: this.job_edit.notification,
        notification_time: this.job_edit.hourly_notification,
        mandatory_portfolio: this.job_edit.mandatory_portfolio,
        mandatory_cv: this.job_edit.mandatory_cv,
        job_scope: this.job_edit.job_scope,
        date_shortlist: this.job_edit.date_shortlist,
        date_conclusion: this.job_edit.date_conclusion,
        has_hometown: this.job_edit.has_hometown,
        source: this.job_edit.source,
        has_is_pcd: this.job_edit.has_is_pcd,
        has_ethnicity: this.job_edit.has_ethnicity,
        has_sexual_orientation: this.job_edit.has_sexual_orientation,
      };

      if (this.job_edit.city_id) {
        this.city.id = this.job_edit.city.id;
        this.city.name = `${this.job_edit.city.name} / ${this.job_edit.city.state.uf}`;
      }

      if (this.job_edit.job_sector_id) {
        this.job_sector.id = this.job_edit.job_sector.id;
        this.job_sector.title = this.toCamelCase(
          this.job_edit.job_sector.title
        );
      }

      if (this.bigfive_edit) {
        this.bigfive.amount_itens = this.bigfive_edit.amount_itens;
      }

      if (this.jobs.maximum_remuneration > 0) this.range_salary = true;

      if (this.job_route_edit) {
        this.job_route = this.job_route_edit;
      }

      if (this.job_video) this.url = this.job_video;
      this.questions = this.questions_record;
    }

    eventBus.$on("saveJob", (field) => {
      this.save();
    });

    eventBus.$on("setJobId", (field) => {
      this.load = false;
      this.job_id = field.data.job.id;
      this.job_route = field.data.job_route_edit;

      if (field.data.gallery) {
        this.gallery_current = field.data.gallery;
      }
    });

    eventBus.$on("setBigfiveId", (data) => {
      this.jobs.bigfive = true;
      this.jobs.bigfive_id = data.bigfive_id;
      this.bigfive.amount_itens = data.amount_itens;
    });

    eventBus.$on("setBigfive", (bool) => {
      this.jobs.bigfive = bool;
    });

    eventBus.$on("setLoad", (field) => {
      this.load = false;
    });

    eventBus.$on("clearInput-cities", () => {
      this.city.id = 0;
      this.city.name = "";
    });

    eventBus.$on("clearInput-job_sectors", () => {
      this.job_sector.id = 0;
      this.job_sector.title = "";
    });

    eventBus.$on("saveQuestion", (field) => {
      this.saveQuestion(field);
    });
  },
  data: () => ({
    job_id: 0,
    has_evaluations: false,
    showKanban: false,
    statusSelected: "",
    skill: "",
    autocompleteItemsSkill: [],
    behavioral: "",
    benefits: "",
    load: false,
    ptBR,
    file: "",
    percent: 0,
    copyText: "",
    url: "",
    job_scopes: [
      { text: "Pública", value: 0 },
      { text: "Privada", value: 1 },
    ],
    statusJob: [
      { text: "Cancelada", value: 0 },
      { text: "Ativa", value: 1 },
      { text: "Paralisada", value: 2 },
      { text: "Concluída", value: 3 },
    ],
    bigfive: {
      amount_itens: 0,
    },
    jobs: {
      candidates_uniques: false,
      recruiter_id: "",
      title: "",
      question_last_work: false,
      description: "",
      benefits: [],
      maximum_remuneration: 0,
      minimum_remuneration: 0,
      hide_upload_cv: false,
      hide_confirm_experiences: false,
      hide_business: false,
      bigfive: false,
      bigfive_id: 0,
      hide_remuneration: false,
      ask_remuneration: false,
      mandatory_cv: false,
      mandatory_portfolio: false,
      allow_notification: true,
      notification_time: moment().hour(9).format("HH:00"),
      link: "",
      skills: [],
      behavioral: [],
      job_scope: 0,
      status: 1,
      date_shortlist: addWeeks(new Date(), 3),
      date_conclusion: addWeeks(new Date(), 4),
      has_hometown: null,
      source: null,
      has_is_pcd: null,
      has_ethnicity: null,
      has_sexual_orientation: null,
    },
    city: {
      id: 0,
      name: "",
    },
    job_sector: {
      id: 0,
      title: "",
    },
    questions: [
      {
        id: 0,
        title: "",
        description: "",
        time: 30,
        number_retakers: 3,
        details: "",
      },
    ],
    range_salary: false,
    job_route: "",
    institutionals: [],
    gallery_current: {},
  }),
  watch: {
    skill: "searchSkills",
  },
  computed: {
    scope_info() {
      if (this.jobs.job_scope === 0)
        return "A vaga ficara visível para você e todos os seus colegas de trabalho";
      return "A vaga ficara visível para você e o administrador da conta";
    },
  },
  methods: {
    setCity(event) {
      this.city.id = event.id;
      this.city.name = event.title;
    },
    toCamelCase(str) {
      let final = "";
      for (let word of str.split(" ")) {
        if (word.length >= 3) word = word[0].toUpperCase() + word.slice(1);
        final += word + " ";
      }
      return final.trim();
    },
    addQuestion() {
      if (this.job_id === 0) {
        this.$toast.info(
          "POR FAVOR, PREENCHA O TÍTULO E DESCRIÇÃOANTES DE ADICIONAR AS QUESTÕES"
        );
        return;
      }

      eventBus.$emit("addQuestion");
    },
    addEvaluations() {
      this.has_evaluations = true;
    },
    async populateKanban() {
      if (this.load != true) {
        await this.save(false, false);
      }
    },
    async getDataKanban(id) {
      axios.get(`/recruiters/jobs/${id}/show`).then((response) => {
        this.job_id = response.data.job.id;
        eventBus.$emit("makeKanbanForm", true);
        this.showKanban = true;
      });
    },
    showSelectTemplate() {
      if (this.job_id === 0) {
        this.$toast.info(
          "POR FAVOR, PREENCHA O TÍTULO E DESCRIÇÃOANTES DE ADICIONAR AS QUESTÕES"
        );
        return;
      }

      this.$modal.show(
        SelectTemplate,
        {},
        {
          width: "50%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    isDuplicated(obj, input) {
      let messages = [
        "Está tag já existe em Habilidades comportamentais",
        "Está tag já existe em Habilidades técnicas",
      ];
      let duplicated = false;
      if (input === 0) {
        for (let tag of this.jobs.skills) {
          if (obj.tag.text.trim() === tag.text.trim()) {
            this.$toast.error("Esta tag já foi inserida");
            return;
          }
        }
        for (let tag of this.jobs.behavioral) {
          if (obj.tag.text === tag.text) {
            duplicated = true;
            break;
          }
        }
      } else {
        for (let tag of this.jobs.skills) {
          if (obj.tag.text === tag.text) {
            duplicated = true;
            break;
          }
        }
      }
      if (duplicated) {
        this.$toast.error(messages[input]);
        return;
      }

      if (input === 0) {
        this.createJobSkill(obj.tag, obj);
        return;
      }
      obj.addTag();
    },
    formatHour() {
      let aux = this.jobs.notification_time;
      if (aux === "")
        this.jobs.notification_time = moment().hour(9).format("HH:00");
      else this.jobs.notification_time = moment(aux, "HH:00").format("HH:00");
    },
    copyCandidateLink() {
      var copyText = document.getElementById("linkShare");
      copyText.select();

      copyText.setSelectionRange(0, 99999); //For mobile devices
      document.execCommand("copy");
      this.onCopy();
      this.saveQuestion(false);
    },
    deleteInstitutional(index) {
      this.$inertia.visit(`/recruiters/jobs/${this.job_id}/edit`, {
        method: "get",
        data: {},
        replace: false,
        preserveState: false,
        preserveScroll: true,
        only: [],
      });
    },
    back() {
      this.saveQuestion(false);
      this.$inertia.visit("/recruiters/jobs", {
        method: "get",
        data: {},
        replace: false,
        preserveState: false,
        preserveScroll: false,
        only: [],
      });
    },
    linkedin() {
      this.saveQuestion(false);
      window.open(
        `https://www.linkedin.com/shareArticle?mini=true&url=${this.job_route}&title=${this.jobs.title}`,
        "_blank"
      );
    },
    addInstitutional() {
      this.$v.jobs.$touch();
      if (this.$v.jobs.$error) {
        this.$toast.error("Preencha corretamente os campos para continuar");
        return;
      }

      this.load = true;
      if (this.load == true) {
        this.institutionals.push({
          name: "",
          video_id: 0,
          id: 0,
          description: "",
          video: "",
          category_id: 5,
          reference_id: this.job_id,
          iframe: "",
        });
      }
    },
    setInstitutionalIndex(event) {
      this.institutionals[event.index].id = event.id;
    },
    sendMovie() {
      this.file = this.$refs.file.files[0];
      this.save();
      this.load = true;
      setTimeout(() => {
        let formData = new FormData();
        formData.append("jobs[video]", this.file);
        this.url = URL.createObjectURL(
          document.querySelector("#capture").files[0]
        );

        let video = document.getElementById("videoCustom");

        video.load();

        video.onloadedmetadata = () => {
          setTimeout(() => {
            axios
              .post(`/recruiters/jobs/${this.job_id}`, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
                onUploadProgress: (progressEvent) => {
                  const totalLength = progressEvent.lengthComputable
                    ? progressEvent.total
                    : progressEvent.target.getResponseHeader(
                        "content-length"
                      ) ||
                      progressEvent.target.getResponseHeader(
                        "x-decompressed-content-length"
                      );

                  if (totalLength !== null) {
                    this.percent = parseInt(
                      (progressEvent.loaded * 100) / totalLength
                    );
                  }
                },
              })
              .then((data) => {
                this.$toast.success("VÍDEO ENVIADO COM SUCESSO");
              })
              .catch((error) => {
                this.load = false;
              });
          }, 150);
        };
      }, 700);
    },
    onCopy: function (e) {
      this.$toast.success("LINK COPIAD COM SUCESSO");
    },
    onError: function (e) {
      this.$toast.success("NÃO FOI POSSÍVEL COPIAR");
    },
    active_job() {
      axios
        .put("/recruiters/jobs/" + this.job_id + "/active")
        .then((response) => {
          this.$toast.success("VAGA ATIVADA COM SUCESSO");
          this.$inertia.visit("/recruiters/jobs", {
            method: "get",
            data: {},
            replace: false,
            preserveState: false,
            preserveScroll: false,
            only: [],
          });
        })
        .catch((error) => {
          this.$toast.error("ERRO AO ATIVAR A VAGA", { position: "top" });
        });
    },
    delete_job() {
      axios.delete("/recruiters/jobs/" + this.job_id).then((response) => {
        this.$toast.success("VAGA ARQUIVADA COM SUCESSO", {
          position: "top",
        });
        this.$inertia.visit("/recruiters/jobs", {
          method: "get",
          data: {},
          replace: false,
          preserveState: false,
          preserveScroll: false,
          only: [],
        });
      });
    },
    requestSave(question_save, load = true) {
      if (load) {
        this.load = true;
      }
      this.$v.jobs.$touch();
      if (this.$v.jobs.$error) {
        this.$toast.error("PREENCHA CORRETAMENTE OS CAMPOS PARA CONTINUAR", {
          position: "top",
        });
        this.load = false;
        return false;
      }

      let url = "/recruiters/jobs";
      if (this.job_id != 0) {
        url = `/recruiters/jobs/${this.job_id}`;
      }

      let skills = [];
      let behavioral = [];
      let benefits = [];

      if (this.jobs.behavioral.length != 0) {
        for (let i = 0; i < this.jobs.behavioral.length; i++) {
          behavioral.push(this.jobs.behavioral[i].text);
        }
      }

      if (this.jobs.benefits.length > 0) {
        for (let i in this.jobs.benefits) {
          benefits.push(this.jobs.benefits[i].text);
        }
      }

      if (!this.range_salary) this.jobs.maximum_remuneration = 0;

      let notificate_user = this.jobs.allow_notification;
      if (notificate_user) notificate_user = 1;
      // Notify
      else notificate_user = 0; // Don't Notify
      if (this.jobs.hide_upload_cv) this.jobs.mandatory_cv = false;

      let sector_id = this.job_sector.id == 0 ? null : this.job_sector.id;
      if (!this.job_sector.title.length) sector_id = null;
      return axios.post(url, {
        jobs: {
          recruiter_id: this.jobs.recruiter_id,
          title: this.jobs.title,
          question_last_work: this.jobs.question_last_work,
          description: this.jobs.description,
          benefits: benefits,
          candidates_uniques: this.jobs.candidates_uniques,
          maximum_remuneration: this.jobs.maximum_remuneration,
          minimum_remuneration: this.jobs.minimum_remuneration,
          hide_remuneration: this.jobs.hide_remuneration,
          hide_upload_cv: this.jobs.hide_upload_cv,
          hide_confirm_experiences: this.jobs.hide_confirm_experiences,
          ask_remuneration: this.jobs.ask_remuneration,
          link: this.jobs.link,
          hide_business: this.jobs.hide_business,
          deleted: this.jobs.deleted,
          skills: skills,
          bigfive: this.jobs.bigfive,
          bigfive_id: this.jobs.bigfive_id,
          behavioral: behavioral,
          status: this.jobs.status,
          notification: notificate_user,
          hourly_notification: this.jobs.notification_time,
          mandatory_portfolio: this.jobs.mandatory_portfolio,
          mandatory_cv: this.jobs.mandatory_cv,
          job_scope: this.jobs.job_scope,
          city_id: this.city.id == 0 ? null : this.city.id,
          job_sector_id: sector_id,
          date_conclusion: this.jobs.date_conclusion,
          date_shortlist: this.jobs.date_shortlist,
          has_hometown: this.jobs.has_hometown,
          has_is_pcd: this.jobs.has_is_pcd,
          has_ethnicity: this.jobs.has_ethnicity,
          has_sexual_orientation: this.jobs.has_sexual_orientation,
        },
      });
    },
    async save(question_save = false, notify = false) {
      await this.createSector();

      await this.requestSave(question_save, true)
        .then((response) => {
          this.load = false;
          this.job_id = response.data.job.id;
          this.gallery_current = response.data.gallery;
          this.job_route = response.data.job_route_edit;
          if (question_save) {
            this.saveQuestion(this.questions, notify);
          }
          this.getDataKanban(this.job_id);
          // this.$inertia.visit(`/recruiters/jobs/${this.job_id}/edit`, {
          //   method: "get",
          //   replace: false,
          //   preserveState: false,
          //   preserveScroll: true,
          // });
          return true;
        })
        .catch((error) => {
          this.load = false;

          this.$toast.error("Erro ao salvar vaga", {
            position: "top",
          });
          return false;
        });
    },
    createSector() {
      if (this.job_sector.id > 0 || this.job_sector.title.length == 0) return;
      let job_sectors = { title: this.job_sector.title.trim() };
      return axios
        .post("/recruiters/job_sectors", { job_sectors })
        .then((response) => {
          this.job_sector.id = response.data.id;
        });
    },
    saveQuestion(questions = false, notify = false) {
      this.load = true;
      let questions_current = [];
      if (questions) {
        this.questions = questions;
      }

      for (let i in this.questions) {
        if (
          this.questions[i].response_type == 2 &&
          Object.keys(this.questions[i].choices).length < 2
        ) {
          this.questions[i].choices = {
            canMarkMoreThanOne: false,
            options: [],
          };
        }

        console.log(this.questions);

        questions_current.push({
          id: this.questions[i].id,
          title: this.questions[i].title,
          description: this.questions[i].description,
          time: this.questions[i].time,
          number_retakers: this.questions[i].number_retakers,
          details: this.questions[i].details,
          job_id: this.questions[i].job_id,
          deleted: this.questions[i].deleted,
          video_id: this.questions[i].video_id,
          response_type: this.questions[i].response_type,
          evaluation_id: this.questions[i].evaluation_id,
          choices: this.questions[i].choices,
          type_order: this.questions[i].type_order,
          selective_process_id: this.questions[i].selective_process_id,
        });
      }

      console.log("+++++++++++++++++++++++++++++++@@@@");
      console.log(questions_current);
      console.log("+++++++++++++++++++++++++++++++@@@");

      axios
        .post("/recruiters/questions", {
          questions: {
            job_id: this.job_id,
            itens: questions_current,
          },
        })
        .then((response) => {
          this.load = false;
          this.$root.$emit("makeKanbanForm");
          eventBus.$emit("getQuestions");

          if (!questions && !notify) {
            return;
          }
          if (!questions.length || notify) {
            this.$toast.success("VAGA SALVA COM SUCESSO", {
              position: "top",
            });
          }
        })
        .catch((error) => {
          this.load = false;
          console.log(error);
        });
    },
    changeSalary() {
      this.range_salary = !this.range_salary;
      if (!this.range_salary) {
        this.maximum_remuneration = 0;
      }
    },
    hasCity(event, items, select) {
      // console.log("-******-------");
      // console.log(select);
      // console.log(event);
      // console.log(items);
      // console.log("-******-------");
      // this.city = items[0] ? items[0] : { id: 0, name: "" };
      // if (!this.city)
      //   this.$toast.error("POR FAVOR, INFORMA A CIDADE DE CANDIDATO(A)S");
    },
  },
  validations: {
    jobs: {
      title: { required, minLength: minLength(4) },
      description: { required, minLength: minLength(5) },
    },
  },
};
</script>